// extracted by mini-css-extract-plugin
export default {"container":"CompanySelect_container__ah-2E","shortSelect":"CompanySelect_shortSelect__xJIja"};